import toggleClass from '@opten/dom/toggle-class';
import { RegExPatterns } from './regexp';

export function validateModel(fieldsToValidate: HTMLInputElement[], submitButtons: HTMLElement[] = null): boolean {
	const validModel = true;
	if (fieldsToValidate && fieldsToValidate.length > 0) {
		// fieldsToValidate.forEach(fieldToValidate => {
		// 	if (validModel && fieldToValidate !== undefined) {
		// 		validModel = validateInput(fieldToValidate, submitButton);
		// 		// if (!validModel) {
		// 		//     (fieldToValidate as HTMLInputElement).focus();
		// 		// }
		// 	} else {
		// 		return;
		// 	}
		// });
		return !fieldsToValidate.map(field => validateInput(field, submitButtons)).filter(valid => !valid).length;
	}
	return validModel;
}

export function validateInput(element: HTMLInputElement, submitButtons?: HTMLElement[]): boolean {
	let isValidInput = element && element !== undefined;
	if (isValidInput && element.required) {
		switch (element.type) {
			case 'checkbox':
				isValidInput = element.checked;
				break;
			case 'password':
				isValidInput = element.value !== undefined && element.value.length > 0 && RegExPatterns.passwordPattern.test(element.value);
				break;
			case 'email':
				isValidInput = element.value !== undefined && element.value.length > 0 && RegExPatterns.eMailPattern.test(element.value);
				break;
			case 'tel':
				isValidInput =
					element.value !== undefined && element.value.length > 0 && RegExPatterns.telephoneNumberPattern.test(element.value);
				break;
			case 'number':
				isValidInput =
					element.value !== undefined && element.value.length > 0 && RegExPatterns.onlyIntegerPattern.test(element.value);
				break;
			case 'radio':
				const radioButtons = Array.from(document.querySelectorAll(`input[name="${element.name}"]`));
				isValidInput = radioButtons.some((item: HTMLInputElement) => item.checked);
				break;
			case 'select-one':
				isValidInput = !!element.value && element.value !== 'null' && !!element.value.trim();
				break;
			default:
				isValidInput = !!element.value && element.value.length > 0;
		}
		let connectedElement = element.parentElement.querySelector("[data-valmsg-for='" + element.id + "']");

		if (!connectedElement) {
			connectedElement = document.querySelector("[data-valmsg-for='" + element.name + "']");
		}

		if (connectedElement) {
			toggleClass(element, 'input-validation-error', isValidInput === false);
			toggleClass(connectedElement, 'field-validation-error', isValidInput === false);
			toggleClass(connectedElement, 'field-validation-valid', isValidInput);
		}
	}
	if (submitButtons && submitButtons.length > 0) {
		submitButtons.forEach(o => toggleClass(o, '--disabled', !isValidInput));
	}

	if (!isValidInput) {
		// console.log(`form field '${element.name}' (${element.type}) is invalid. value was : '${element.value}'`);
	}

	return isValidInput;
}
